import type { IconData } from '@stacksjs/iconify-core'

export const pe4x3: IconData = {
  "body": "<path fill=\"#D91023\" d=\"M0 0h640v480H0z\"/><path fill=\"#fff\" d=\"M213.3 0h213.4v480H213.3z\"/>",
  "width": 640,
  "height": 480,
  "viewBox": "0 0 640 480"
}

export default pe4x3
